module.exports = __webpack_public_path__ + "static/media/Fully Custom.2bca0b23.svg";